<template>
  <div id="main-dashboard">
    <NavBar/>
    <vue-progress-bar></vue-progress-bar>
    <div class="container main-container">
      <div class="row justify-content-md-center justify-content-md-center">
        <div class="col-12 text-center">
          <div class="container">
            <ProfileCard
              v-bind:user="$store.state.user"
              v-bind:couponsSummary="$store.state.couponsSummary"
            />
          </div>
        </div>
      </div>
      <div class="row icons align-bottom fixed-bottom">
        <hr>
        <div class="col-12 mb-1 text-left align-items-center divider">
          <div class="row align-items-center justify-content-md-center">
            <div
              class="col-6 col-md-3 align-items-center text-center menu-button"
              v-on:click="goTo('ordersToSend')"
            >
              <img class="icon" src="../assets/icon-send.png" width="25">
              <span class="text-nowrap">Enviar de Prendas</span>
            </div>

            <div
              class="col-6 col-md-3 align-items-center text-center menu-button"
              v-on:click="goTo('ordersToReceive')"
            >
              <img class="icon" src="../assets/icon-receive.png">
              <span class="text-nowrap">Recibir Prendas</span>
            </div>

            <div
              class="col-6 col-md-3 align-items-center text-center menu-button"
              v-on:click="goTo('myOrders')"
            >
              <img class="icon med" src="../assets/icon-orders.png">
              <span class="text-nowrap">Mis Ordenes</span>
            </div>

            <div
              class="col-6 col-md-3 align-items-center text-center small-button menu-button"
              v-on:click="goTo('ordersObserved')"
            >
              <img class="icon" src="../assets/icon-cupon.png">
              <span class="text-nowrap">Ordenes Observadas</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "../components/NavBar";
import ProfileCard from "../components/ProfileCard";

export default {
  name: "home",
  created() {
    //this.$store.commit("refreshUser");
  },
  components: {
    NavBar,
    ProfileCard
  },
  methods: {
    goTo: function(name) {
      this.$router.push(name);
    }
  },
  data: function() {
    return {
      orders: [],
      loading: true
    };
  }
};
</script>

<style>
.icons {
  display: flex;
}

.icons span {
  display: block;
  cursor: pointer;
  color: #696969;
}
img.icon {
  cursor: pointer;
  width: 25px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.menu-button {
  border-left: 1px solid rgba(67, 67, 67, 0.2);
  border-top: 1px solid rgba(67, 67, 67, 0.2);
  padding-bottom: 11px;
  min-height: 96px;
  background-color: #fff;
}
.small-button img {
  margin-top: 30px;
  margin-bottom: 15px;
}
img.med {
  margin-top: 23px !important;
}
.main-container {
  min-height: 100%;
}
#main-dashboard {
  padding-bottom: 150px;
}
</style>
